import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { IssueTypeSettingsDetailViewTopBar } from "./TopBar"

export const issueTypeDetailsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: IssueTypeSettingsDetailViewTopBar,
}
